import { useCallback, useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import {
  selectMeteorologyAgroWBSequentialMapsVariable,
  setVariable as setVariableRedux,
} from 'redux/reducers/meteorologyAgroWBSequentialMapsReducer';
import { store } from 'redux/store';
import useOptions from './useOptions';

export default function useVariables() {
  const { options } = useOptions();

  const variables = useMemo(() => {
    if (!options) return [];

    const visibleVariables = options.variables.filter((variable) => !variable.hidden);
    const sortedVariables = visibleVariables.sort((a, b) => a.order - b.order);
    return sortedVariables.map((variable) => ({
      value: variable.value,
      label: variable.label,
    }));
  }, [options]);

  useEffect(() => {
    store.dispatch(setVariableRedux(variables[0]?.value));
  }, [variables]);

  const variable = useSelector(selectMeteorologyAgroWBSequentialMapsVariable);
  const setVariable = useCallback((newVariable: React.SetStateAction<string | undefined>) => {
    store.dispatch(setVariableRedux(newVariable && newVariable.toString()));
  }, []);

  const variableLabel = variables.find((v) => v.value === variable)?.label;

  const unit = useMemo(() => {
    const variableOptions = options?.variables.find((v) => v.value === variable);
    return variableOptions?.unit || '';
  }, [options, variable]);

  const config = useMemo(() => {
    const variableOptions = options?.variables.find((v) => v.value === variable);
    return variableOptions?.config || undefined;
  }, [options, variable]);

  return {
    variables,
    variable,
    setVariable,
    variableLabel,
    unit,
    config,
  };
}
